export enum RefundOptions {
  FULL_REFUND = 'fullRefund',
  ACCORDING_POLICY = 'accordingToPolicy',
  NO_REFUND = 'noRefund',
}